<template>
  <div class="tab tabs__tab tabs__tab--pricing pricing">
    <div class="loading-indicator loading-indicator--full-page" v-if="!globalLoading && (needsInit || downloadInProgress)">
      <MoonLoader size="75px" color="#ffffff"></MoonLoader>
      <div class="loadingText">Loading</div>
    </div>
    <div v-else>
      <div class="panel panel--shaded grid">
        <div class="grid__col--3">
          <v-select class="filter-selection__select h-full-width" v-model="selectedManufacturer" :options="manufacturers" options-value="name" options-label="name" placeholder="Select Manufacturer"></v-select>
        </div>
        <div class="grid__col--2">
          <a class="btn btn-primary btn-block fuel-utilization__search-submit" :disabled="!selectedManufacturer" @click.stop="downloadPricing">Export</a>
        </div>
        <div class="grid__col--2"></div>
        <div class="grid__col--3 h-right-align">
          <form v-on:submit.prevent>
            <div class="input-group search__container">
              <span class="input-group-addon search__button" id="basic-addon1"><span class="glyphicon glyphicon-search" aria-hidden="true"></span></span>
              <input type="text" class="form-control search__input" placeholder="Search..." v-model="search">
            </div>
          </form>
        </div>
      </div>
      <Items
          v-if="selectedMfgObject"
          :search-string="search"
          :selected-mfg-object="selectedMfgObject"
      ></Items>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import vSelect from 'vue-strap/src/Select.vue';
  import Items from '../pricing-guides/Items.vue';

  export default {
    name: 'PricingGuidesLayout',
    components: {
      MoonLoader,
      Items,
      vSelect,
    },
    data() {
      return {
        selectedManufacturer: null,
        selectedMfgObject: null,
        search: '',
      };
    },
    mounted() {
      if (this.needsInit) {
        this.init();
      }
    },
    watch: {
      selectedManufacturer() {
        if (this.selectedManufacturer) {
          this.selectedMfgObject = {
            ...lodash.find(this.manufacturers, { name: this.selectedManufacturer }),
            ...this.pricing[this.selectedMfgNameSlug],
          };
        }
      },
    },
    computed: {
      ...mapGetters('main', ['globalLoading']),
      ...mapGetters('pricingGuides', ['manufacturers', 'pricing', 'loaders', 'sortProp', 'sortDir', 'downloadInProgress']),
      needsInit() {
        return this.manufacturers.length === 0 || !this.pricing;
      },
      selectedMfgNameSlug() {
        return this.selectedManufacturer ? this.selectedManufacturer.toLowerCase() : null;
      },
      sortClass() {
        return this.sortDir === 'asc' ? 'glyphicon-arrow-up' : 'glyphicon-arrow-down';
      },
    },
    methods: {
      init() {
        this.$store.dispatch('pricingGuides/getManufacturers');
        this.$store.dispatch('pricingGuides/getPricing');
      },
      downloadPricing() {
        if (this.downloadInProgress) {
          return;
        }
        this.$store.dispatch('pricingGuides/downloadPricing', this.selectedMfgNameSlug);
      },
    },
  };
</script>
